var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.8 0 0.382812 3.41719 0.382812 7.61719V15.6516H7.41406V13.157C5.34805 12.8707 3.75195 11.093 3.75195 8.94922C3.75195 6.60703 5.65781 4.70156 8 4.70156C10.3422 4.70156 12.248 6.60703 12.248 8.94922C12.248 11.093 10.652 12.8707 8.58594 13.157V15.6516H15.6172V7.61719C15.6172 3.41719 12.2 0 8 0Z",
    fill: "#773DD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.51b0a167c3f0853910cc4cf600b4da55.svg";
export { ForwardRef as ReactComponent };